import React, { useEffect, useRef, useState } from 'react'
import styles from './headerBlack.module.css'; 
import { auth, db } from '../../../firebase/firebase'; 
import { signOut } from 'firebase/auth';
import logo from '../../../assets/img/CliP blanc- logo.png';
import profileIcon from '../../../assets/img/profileIcon.png';
import { Link, useNavigate } from 'react-router';
import acceuil from '../../../assets/img/acceuil.png'
import logoPro from '../../../assets/img/CliP pro blanc- logo.png'
import { collection, query, where, getDocs } from 'firebase/firestore';

const HeaderBlack = () => {
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const profileDropdownRef = useRef(null);
    const navigate = useNavigate();
  
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            setCurrentUser(user);
            if (user) {
                try {
                    // Create a query to find the medecin document with matching email
                    const medecinsRef = collection(db, 'medecins');
                    const q = query(medecinsRef, where('email', '==', user.email));
                    const querySnapshot = await getDocs(q);
                    
                    if (!querySnapshot.empty) {
                        // Get the first matching document
                        const userDoc = querySnapshot.docs[0];
                        setUserRole(userDoc.data().role);
                        /*console.log("User role:", userDoc.data().role); // Debug log*/
                    } else {
                        /*console.log("No medecin found with email:", user.email);*/
                    }
                } catch (error) {
                    /*console.error("Error fetching user role:", error);*/
                }
            }
        });

        return () => unsubscribe();
    }, []);

    // Handle logout
    const handleLogout = async () => {
      try {
        await signOut(auth);
        navigate('/'); // Redirect to login page after logout
      } catch (error) {
        /*console.error('Logout failed:', error);*/
      }
    };
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
          setIsProfileDropdownOpen(false);
        }
      };
  
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, []);
  
    const handleProfileClick = (e) => {
      e.stopPropagation();
      setIsProfileDropdownOpen(!isProfileDropdownOpen);
    };

    // Debug log for rendering
    /*console.log("Current userRole:", userRole);*/
  
    return (
        <header className={styles.header}>
            <nav className={styles.nav}>
              <div className={styles.logo}>
                <img 
                    src={userRole === 'orthodontiste' ? logoPro : logo} 
                    alt={userRole === 'orthodontiste' ? "Diamond Pro Logo" : "Diamond Logo"} 
                    className={styles.logoImage}
                />
                {currentUser && (
                    <span className={styles.accdiv}>
                        <img src={acceuil} alt="" className={styles.navIcon} />
                        <Link to="/profile" className={styles.navlink}>
                            Accueil
                        </Link>
                    </span>
                )}
              </div>
              <div className={styles.navRight}>
                <Link to="/support" className={styles.navLink}>Support</Link>
                <select className={styles.languageSelect}>
                  <option value="fr">FR</option>
                  <option value="en">EN</option>
                </select>
                <div className={styles.userProfile}>
                  <div className={styles.profileSection} ref={profileDropdownRef}>
                    <button className={styles.profileBtn} onClick={handleProfileClick}>
                      <img src={profileIcon} alt="Profile" className={styles.profileImg} />
                    </button>
                    <div className={`${styles.profileDropdown} ${isProfileDropdownOpen ? styles.active : ''}`}>
                      <Link to="/profileMedecin" className={styles.dropdownItem}>Mon compte</Link>
                      <button onClick={handleLogout} className={styles.dropdownItem}>Se déconnecter</button>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
        </header>
    );
};

export default HeaderBlack;